Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.OptionView extends Backbone.View

  template: JST['backbone/templates/monitoring/reports/publications/option']

  initialize: (@subsections = {}) ->
    # just set @sections

  render: ->
    @$el.html(@template( {subsections: @subsections } ))
    return this
